// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fl-block{\r\n    float: left;\r\n    min-width: 80%;\r\n}", "",{"version":3,"sources":["webpack://./src/app/projects/edit-sales-order/engg-draw/engg-draw.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;AAClB","sourcesContent":[".fl-block{\r\n    float: left;\r\n    min-width: 80%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
